import { ColDef, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo } from "react";

import { IgPaper, IgTableWrapper } from "@intelligems/ig-theme";
import {
  FullAgencyDto,
  FullOrganizationAgencyLinkDto,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { DeleteColumn } from "@src/features/admin/pages/agencies/components/Tables/AgencyOrganizationsTable/renderers/DeleteColumn";
import { theme } from "@src/theme";

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

interface OrganizationAgencyLinkTableProps {
  agency: FullAgencyDto;
  orgs: FullOrganizationAgencyLinkDto[];
}

export const AgencyOrganizationsTable = ({
  agency,
  orgs,
}: OrganizationAgencyLinkTableProps) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
      suppressHeaderMenuButton: true,
      suppressHeaderContextMenu: true,
    };
  }, []);

  const columnDefs: ColDef<FullOrganizationAgencyLinkDto & { "": "" }>[] =
    useMemo(
      () => [
        {
          headerName: "Name",
          field: "organization.name",
          sortable: true,
          filter: "agTextColumnFilter",
        },

        {
          headerName: "",
          field: "",
          cellRenderer: DeleteColumn,
          cellStyle: { justifyContent: "end" },
          maxWidth: 120,
        },
      ],
      []
    );

  return (
    <Grid item>
      <IgTableWrapper minHeight={"100px"} height={null}>
        <AgGridReact<FullOrganizationAgencyLinkDto>
          theme={myTheme}
          rowData={orgs}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          headerHeight={25}
          masterDetail={true}
          domLayout={"autoHeight"}
          detailRowAutoHeight={true}
          context={{ agency }}
          suppressCellFocus={true}
          suppressRowHoverHighlight={true}
        />
      </IgTableWrapper>
    </Grid>
  );
};
